<div class="circle_initials" [ngClass]="setColorForCircle(data)" [style]="'width: ' + size + 'px !important; height: ' + size + 'px !important;'">
    <p class="fw-semibold">{{obtenerLetraNombreApellido(data.nombreCompleto)}}</p>
</div>